import React from "react";
import { Alert, Text } from "@mantine/core";
import { FaInfoCircle } from "react-icons/fa";
import { useAppSelector } from "../../../app/hooks";
import { selectCurrentRoomIfcDesignItemCount } from "./similarRoomsWithIfcDesignViewerSelectors";

export const CurrentRoomIfcDesignWarningBanner: React.FC = () => {
  const currentRoomIfcDesignItemCount = useAppSelector(selectCurrentRoomIfcDesignItemCount);

  if (currentRoomIfcDesignItemCount === 0) {
    return null;
  }

  return (
    <Alert variant="light" color="yellow" icon={<FaInfoCircle size={14} />} py="xs">
      <Text size="xs" fw={600}>
        Aktuellt rom har allerede {currentRoomIfcDesignItemCount} komponenter i IFC.
      </Text>
    </Alert>
  );
};
